/* IC nav dropdown: attaches Seed-style panels to the header's desktop menu items (>= 1100px, mouse/trackpad).
   Panel templates come from sections/ic-nav-dropdown.liquid, matched to menu items by their title. */
(() => {
  const DESKTOP = matchMedia('(min-width: 1100px) and (hover: hover)');
  const CLOSE_DELAY = 300;
  const handle = s => s.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  function init() {
    const root = document.querySelector('[data-icnd]');
    const nav = document.querySelector('.header__inline-menu');
    if (!root || !nav || root.dataset.ready) return;
    root.dataset.ready = '1';
    const shell = root.querySelector('[data-icnd-shell]');
    const inner = root.querySelector('[data-icnd-inner]');
    const panels = {};
    root.querySelectorAll('template[data-icnd-panel]').forEach(t => { panels[t.dataset.icndPanel] = t; });

    const items = [...nav.querySelectorAll(':scope > ul > li')].filter(li => {
      const a = li.querySelector(':scope > a');
      const key = a && handle(a.getAttribute('aria-label') || a.textContent);
      if (!key || !panels[key]) return false;
      li.dataset.icnd = key;
      li.classList.add('icnd-item');
      return true;
    });
    if (!items.length) return;
    document.documentElement.classList.add('icnd-ready');

    // Sliding pill behind the hovered item
    nav.style.position = 'relative';
    const pill = document.createElement('span');
    pill.className = 'icnd-pill';
    nav.prepend(pill);

    let current = null, closeT = null, swapT = null, suppress = false;

    const place = li => {
      const a = li.querySelector(':scope > a');
      const nr = nav.getBoundingClientRect(), ar = a.getBoundingClientRect();
      // Pill = the link's width, 38px tall and centred on the word, like the mint sub-nav hover
      const PILL_H = 38;
      pill.style.left = (ar.left - nr.left) + 'px';
      pill.style.width = ar.width + 'px';
      pill.style.top = (ar.top - nr.top + (ar.height - PILL_H) / 2) + 'px';
      pill.style.height = PILL_H + 'px';
      pill.style.opacity = '1';
      items.forEach(i => i.classList.toggle('icnd-hover', i === li));
      const header = document.querySelector('.shopify-section-header') || nav;
      const top = header.getBoundingClientRect().bottom + 8;
      const left = Math.max(16, Math.min(ar.left, innerWidth - 376));
      return { top, left };
    };
    const measure = () => {
      shell.style.height = 'auto';
      const h = shell.scrollHeight;
      return h;
    };

    function open(li) {
      if (!DESKTOP.matches || suppress) return;
      clearTimeout(closeT);
      const key = li.dataset.icnd;
      const pos = place(li);
      shell.style.top = pos.top + 'px';
      if (current === key && shell.classList.contains('is-open')) return;
      if (!current || !shell.classList.contains('is-open')) {
        // First open: no resize or slide from a previous tab
        inner.replaceChildren(panels[key].content.cloneNode(true));
        const prev = shell.style.transition;
        shell.style.transition = 'none';
        shell.classList.remove('is-closing');
        shell.style.left = pos.left + 'px';
        shell.style.height = measure() + 'px';
        void shell.offsetHeight;
        shell.style.transition = prev;
        shell.classList.add('is-open');
        shell.setAttribute('aria-hidden', 'false');
      } else {
        // Switch tabs: slide/resize the panel, fade the old content out, then the new content in
        shell.style.left = pos.left + 'px';
        inner.classList.add('is-swapping');
        clearTimeout(swapT);
        swapT = setTimeout(() => {
          const from = shell.getBoundingClientRect().height;
          inner.replaceChildren(panels[key].content.cloneNode(true));
          shell.style.height = from + 'px';
          const to = measure();
          shell.style.height = from + 'px';
          void shell.offsetHeight;
          shell.style.height = to + 'px';
          inner.classList.remove('is-swapping');
        }, 150);
      }
      current = key;
      items.forEach(i => i.querySelector(':scope > a').setAttribute('aria-expanded', i === li ? 'true' : 'false'));
    }

    function close(now) {
      clearTimeout(closeT);
      const run = () => {
        shell.classList.add('is-closing');
        shell.classList.remove('is-open');
        shell.setAttribute('aria-hidden', 'true');
        pill.style.opacity = '0';
        items.forEach(i => { i.classList.remove('icnd-hover'); i.querySelector(':scope > a').setAttribute('aria-expanded', 'false'); });
        current = null;
        setTimeout(() => { if (!current) shell.classList.remove('is-closing'); }, 320);
      };
      now ? run() : (closeT = setTimeout(run, CLOSE_DELAY));
    }

    items.forEach(li => {
      const a = li.querySelector(':scope > a');
      a.setAttribute('aria-haspopup', 'true');
      a.setAttribute('aria-expanded', 'false');
      li.addEventListener('mouseenter', () => open(li));
      li.addEventListener('mouseleave', () => close());
      a.addEventListener('focus', () => open(li));
    });
    shell.addEventListener('mouseenter', () => clearTimeout(closeT));
    shell.addEventListener('mouseleave', () => close());
    shell.addEventListener('focusin', () => clearTimeout(closeT));
    document.addEventListener('focusin', e => {
      if (current && !shell.contains(e.target) && !items.some(li => li.contains(e.target))) close(true);
    });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || !current) return;
      const li = items.find(i => i.dataset.icnd === current);
      close(true);
      suppress = true; // returning focus to the link must not re-open the panel
      if (li) li.querySelector(':scope > a').focus({ preventScroll: true });
      setTimeout(() => { suppress = false; }, 50);
    });
    addEventListener('resize', () => { if (current) close(true); }, { passive: true });
    DESKTOP.addEventListener('change', () => close(true));
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', () => { const r = document.querySelector('[data-icnd]'); if (r) { delete r.dataset.ready; init(); } });
})();
